<sd-push-card
  (clicked)="onClick($event)"
  (carouselClicked)="onCarouselClicked()"
  [brand]="brand"
  [isLoading]="isLoading"
  [indexFollow]="data?.push?.indexFollow !== undefined ? data?.push?.indexFollow : true"
  [textConfig]="data?.push?.textConfig"
  [mediaAsBackground]="false"
  [push]="data?.push?.push"
  [twicPicsAutoSize]="false"
  [pushSize]="pushSizeEnum.l"
  [imageRatio]="isMobile$ ? imageRatioEnum.r15_8 : imageRatioEnum.r2_1"
  [mediaConfig]="data?.push?.mediaConfig"
  [hasModal]="data?.push?.hasModal"
  [isDescription]="data?.push?.isDescription"
  [titleLevel]="data?.push?.titleLevel"
  [themesConfig]="data?.push?.themesConfig"
/>

@if (data?.miniPush?.length > 0) {
  <div class="c__mini-content">
    @for (miniPush of data?.miniPush; track $index) {
      <sd-mini-push-card
        (carouselClicked)="onCarouselClicked($index)"
        [brand]="brand"
        [isLoading]="isLoading"
        [push]="miniPush"
        [isDescription]="miniPush?.richParagraph?.heading?.isDescription"
        [titleLevel]="miniPush?.richParagraph?.heading?.titleLevel"
        [isFit]="isFit"
        [twicPicsAutoSize]="false"
      />
    }
  </div>
}
